<template>
    <div>
        <van-nav-bar
                title="我的银行卡"
                left-arrow
                :fixed="true"
                class="my-nav"
                @click-left="$router.back(-1)"
                :z-index="100"
        />
        <div v-if="bankList.length===0"
             style=" height: 150px;margin: 0 auto; text-align: center;padding: 20px; color: #666; margin-top: 50%;">
            <img src="../../assets/images/empty.png" style="width: inherit; height: 100%"/>
            <div style="padding: 10px 0">暂未绑卡!</div>
            <van-button size="small" @click="$router.push('/ql-bank-card/binding')">去绑卡</van-button>
        </div>
        <div style="margin-top: 20%;margin-left: 16px;"  v-else>
            <div style="height: 120px; margin-right:3.4%;margin-top: 20px;background-color: #FEFEFE;border: solid 1px #f0f0f0;border-radius: 5px;box-shadow: 3px -3px 6px #f2f2f2 "
                 v-for="(bank,index) in bankList">
                <div>
                    <img style="height: 33px;width: 150px;padding: 10px;"  v-if="isImg(bank.name) != undefined"  :src="imgUrl(bank.name)" />
                    <p style="font-size: 14px;padding-left: 10px;" v-else>{{bank.name==''?'-------':bank.name}}</p>
                </div>
                <div style="border-bottom: 1px dashed #f0f0f0;padding-left: 10px;">{{bank.card}}</div>
                <div style="padding: 10px 0 10px 10px;">
                    <div style="font-size: 14px;float: left;">{{bank.accountName}}</div>
                    <div style="float: right;margin-right: 5%;">
                        <van-button type="warning" size="mini" @click="deleteBank(bank.card)">解绑</van-button>
                    </div>
                </div>
            </div>
        </div>


        <div style="position: absolute;
    width: 100%;
    bottom: 0;">
                <van-button block type="danger" class="van-address-list__add"  style="z-index: 10001; " @click="addBankCard">新增银行卡</van-button>
        </div>
    </div>
</template>

<script>
  import {Toast} from 'vant'
  import {bankCardList,deleteBankCard,img} from '../../api/ql-bank-card'
  export default {
      data() {
          return {
              bankList:[],
              bankinfo:{
                  cardType:'',
                  bank:'',
                  key:''
              }
          }
      },
      mounted() {
          this.getBankCardInfo();
      },

      methods: {
          /**
           * 获取银行卡信息
           */
          getBankCardInfo() {
              var _this = this;
              bankCardList(function (res) {
                  _this.bankList = res;
              })
          },
          /**
           * 解绑银行卡
           */
          deleteBank(value){
              var _this = this;
              deleteBankCard(value,function (res) {
                  Toast.success("银行卡解绑成功");
                  _this.getBankCardInfo();
              })
          },
          imgUrl(bankName){
              var bankNameUrl = img.getUrl(bankName);
              return require('@/assets/images/bank/'+bankNameUrl+'.png');
          },
          isImg(bankName){
              return img.isImg(bankName);
          },
          addBankCard(){
              this.$router.push('/ql-bank-card/binding')
          }
      }
  }
</script>

<style lang="less" scoped>
.van-address-list__add{
    height: 50px;
}
</style>
